import {
  Component,
  ElementRef,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { Button } from '../button/button';

@Component({
  selector: 'app-modal',
  templateUrl: 'modal.html',
  imports: [Button],
})
export class Modal {
  label = input.required<string>();
  description = input<string>();
  confirmed = output<true>();

  readonly dialogElement = viewChild.required('dialogElement', {
    read: ElementRef<HTMLDialogElement>,
  });

  isOpen = signal<boolean>(false);

  open() {
    this.dialogElement().nativeElement.showModal();
    this.isOpen.set(true);
  }

  close() {
    this.dialogElement().nativeElement.close();
    this.isOpen.set(false);
  }

  confirm() {
    this.confirmed.emit(true);
    this.close();
  }
}
